import { classed } from "@trydig/ui";
import styles from "./IconButton.module.css";

export const IconButton = classed("button", styles.root);
